import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../frontend/components/Header';
import Footer from '../frontend/components/Footer';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    message: '',
    interest: 'general'
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send to your backend
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <div className="contact-page">
      {/* Header */}
      <Header />
      <header className="page-header bg_cover" style={{ backgroundImage: 'linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(/assets/images/home-one/hero/hero-bg.jpg)' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center pt-100 pb-100">
              <h1 className="text-white mb-3">Get in Touch</h1>
              <p className="text-white-50 lead">Have questions? We'd love to hear from you.</p>
              <Link to="/" className="theme-btn style-two mt-4">Back to Home</Link>
            </div>
          </div>
        </div>
      </header>

      {/* Contact Content */}
      <section className="contact-content pt-80 pb-80">
        <div className="container">
          <div className="row">
            {/* Contact Info */}
            <div className="col-lg-5 mb-5 mb-lg-0">
              <div className="contact-info-box p-4 bg-light rounded h-100">
                <h4 className="mb-4">Contact Information</h4>
                
                <div className="contact-item mb-4 d-flex">
                  <i className="fas fa-map-marker-alt text-orange fs-4 me-3 mt-1"></i>
                  <div>
                    <h6>Our Office</h6>
                    <p className="mb-0 text-muted">
                      Plot 688 Ahmodu Tijani Close,<br />
                      Off Sanusi Fafunwa Street,<br />
                      Victoria Island, Lagos State, Nigeria
                    </p>
                  </div>
                </div>

                <div className="contact-item mb-4 d-flex">
                  <i className="fas fa-phone text-orange fs-4 me-3 mt-1"></i>
                  <div>
                    <h6>Phone</h6>
                    <p className="mb-0 text-muted">+234 (815) 159-0112</p>
                    <small className="text-muted">Mon-Fri, 9am-6pm WAT</small>
                  </div>
                </div>

                <div className="contact-item mb-4 d-flex">
                  <i className="fas fa-envelope text-orange fs-4 me-3 mt-1"></i>
                  <div>
                    <h6>Email</h6>
                    <p className="mb-0 text-muted">info@fsl.ng</p>
                    <small className="text-muted">We respond within 24 hours</small>
                  </div>
                </div>

                <div className="contact-item d-flex">
                  <i className="fas fa-clock text-orange fs-4 me-3 mt-1"></i>
                  <div>
                    <h6>Support Hours</h6>
                    <p className="mb-0 text-muted">24/7 Emergency Support for Partners</p>
                  </div>
                </div>

                <div className="mt-5">
                  <h6 className="mb-3">Follow Us</h6>
                  <div className="social-links d-flex gap-3">
                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-orange fs-5"><i className="fab fa-facebook-f"></i></a>
                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-orange fs-5"><i className="fab fa-twitter"></i></a>
                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-orange fs-5"><i className="fab fa-linkedin-in"></i></a>
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-orange fs-5"><i className="fab fa-instagram"></i></a>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-lg-7">
              <div className="contact-form-box p-4 p-md-5 border rounded">
                <h4 className="mb-4">Send us a Message</h4>
                
                {submitted && (
                  <div className="alert alert-success" role="alert">
                    <i className="fas fa-check-circle me-2"></i>
                    Thank you! Your message has been sent successfully.
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Full Name *</label>
                      <input 
                        type="text" 
                        className="form-control" 
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required 
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Email Address *</label>
                      <input 
                        type="email" 
                        className="form-control" 
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required 
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Company Name</label>
                      <input 
                        type="text" 
                        className="form-control" 
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Phone Number</label>
                      <input 
                        type="tel" 
                        className="form-control" 
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">I'm interested in *</label>
                    <select 
                      className="form-select" 
                      name="interest"
                      value={formData.interest}
                      onChange={handleChange}
                      required
                    >
                      <option value="general">General Inquiry</option>
                      <option value="partnership">Partnership Opportunity</option>
                      <option value="api">API Integration</option>
                      <option value="support">Technical Support</option>
                      <option value="sales">Sales Demo</option>
                    </select>
                  </div>

                  <div className="mb-4">
                    <label className="form-label">Message *</label>
                    <textarea 
                      className="form-control" 
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows="5"
                      required
                    ></textarea>
                  </div>

                  <button type="submit" className="theme-btn style-one w-100">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
        <Footer/>
    </div>
    
  );
};

export default ContactPage;